module.exports = __webpack_public_path__ + "static/media/SeaBgRural.a4d6a39c.svg";